import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatCalendarCellClassFunction, MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-calendar-header',
  templateUrl: './calendar-header.component.html',
  styleUrls: ['./calendar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CalendarHeaderComponent {
  @Input() loading = false;
  @Input() focusDate = new Date();
  @Input() firstOfWeek: Date | null = null;
  @Input() lastOfWeek: Date | null = null;
  @Output() jumpToDate: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() prev: EventEmitter<null> = new EventEmitter<null>();
  @Output() next: EventEmitter<null> = new EventEmitter<null>();

  @ViewChild('jumpToDatePicker') jumpToDatePicker: MatDatepicker<Date>;

  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  selectedDateChanged(date?: Date) {
    if (date) {
      // Datepicker
      this.jumpToDate.emit(date);
    } else {
      // Today button
      this.jumpToDate.emit(new Date());
    }
  }

  /** When in month view, close & jump to month when month selected */
  monthSelected(date: Date) {
    if (!(this.firstOfWeek && this.lastOfWeek)) {
      this.jumpToDatePicker.close();
      this.jumpToDate.emit(date);
    }
  }

  /** Formats date range display for week view */
  formatDateRange(start: Date, end: Date, fullMonth: boolean, showYear: boolean): string {
    const startMonth = start.toLocaleString('default', { month: fullMonth ? 'long' : 'short' });
    const endMonth = end.toLocaleString('default', { month: fullMonth ? 'long' : 'short' });
    const startDate = start.getDate();
    const endDate = end.getDate();
    const year = end.getFullYear();

    if (startMonth === endMonth) {
      // If same month, only show month on start date
      return showYear
        ? `${startMonth} ${startDate} - ${endDate}, ${year}`
        : `${startMonth} ${startDate} - ${endDate}`;
    } else {
      // Otherwise, show both months
      return showYear
        ? `${startMonth} ${startDate} - ${endMonth} ${endDate}, ${year}`
        : `${startMonth} ${startDate} - ${endMonth} ${endDate}`;
    }
  }

  /** Custom hover/selection display in week view calendar selector */
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Special hover state for week view
    if (this.firstOfWeek && this.lastOfWeek) {
      return 'week-selector-cell';
    }

    return '';
  };
}
